<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <div class="form-wrapper" style="background-color: #0a4d94;">
      <h3 style="margin: 2%; margin-left: 3%; color: white;">Site #{{$attrs.siteNumber}}</h3>
      <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist" style="margin-left: 2%; border-bottom: none;">
        <div v-for="(route, index) in routes" id="apptabs">
            <router-link class="nav-item nav-link"
                         :to="{name: route, query: $route.query}"
                         v-bind:key="route"
                         v-bind:class="{visited: index < currentRoute}">
              {{routeTags[index]}}
            </router-link>
            </div>
        <a class="nav-item nav-link" style="text: white;" href="#/air/siteauth"
            @click="changeSite">
          Change Site
        </a>
        </div>
      </nav>
    </div>
    <div class="form-wrapper" style="border-top: none;">
          <router-view :form="form"
                       :val="$v"
                       class="h-100 d-flex align-content-between flex-wrap"
                       v-bind:fetchingData.sync="fetchingData"
                       v-bind:title.sync="title">
          </router-view>
    </div>
  </div>
</template>
<script>
import { AirAddEquipmentForm } from '~/js/FormObjects';
import { CapitalizeFilter } from '@/js/Mixins';

export default {
  name: 'Application',
  props: {

  },
  mixins: [CapitalizeFilter],
  data() {
    return {
      title: null,
      currentRoute: null,

      routes: [
        'AccountStatementsDefault',
        //'SiteEquipment',
        'AddEquipment'
      ],
      routeTags: [
        'Statement of Account',
        //'Deactivate Equipment',
        'Register New Equipment'
      ],
      permitPrices: [],
      form: new AirAddEquipmentForm(),
      fetchingData: false,
    };
  },
  mounted() {
    this.currentRoute = 0;
    this.$router.push({ name: 'AccountStatementsDefault', query: this.$route.query });
  },
  validations: {
  },
  methods: {
    changeSite() {
      this.$router.push({ name: 'SiteAuthentication', query: this.$route.query });
    },
  },
  watch: {
    $route(to) {
      const toRoute = this.routes.findIndex(route => to.name.endsWith(route));
      if (toRoute != this.currentRoute) {
        this.currentRoute = toRoute;
      }
    },
    'form.scanning': function () {
      if (this.form.scanning > 0) {
        document.getElementsByClassName('equipment-detail-links')[2].classList.add('disabled');
      } else {
        document.getElementsByClassName('equipment-detail-links')[2].classList.remove('disabled');
      }
    },
  },
};
</script>
